import { Link } from 'react-router-dom';
import './BlogCard.css';

const BlogCard = ({ to, image, category, title, date, author, excerpt }) => (
  <Link to={to} className="blog-card-link">
    <article className="blog-card">
      <div
        className="blog-card-image"
        style={{ backgroundImage: image ? `url(${image})` : undefined }}
      />
      <div className="blog-card-content">
        {category && <span className="blog-card-category">{category}</span>}
        <h4 className="blog-card-title">{title}</h4>
        {excerpt ? <p className="blog-card-excerpt">{excerpt}</p> : null}
        {date && <p className="blog-card-date">{date}</p>}
        <div className="blog-card-footer-row">
          {author && <p className="blog-card-author">by {author}</p>}
          <span className="blog-card-read-more">
            Read More
            <img
              src="/assets/arrow-up-right.svg"
              alt=""
              className="blog-card-read-more-icon"
              width={16}
              height={16}
              aria-hidden
            />
          </span>
        </div>
      </div>
    </article>
  </Link>
);

export default BlogCard;

